export default __webpack_public_path__ + "static/media/190.b02ff0bd.jpg";